var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 96.1908C75.5105 96.1908 96.1908 75.5105 96.1908 50C96.1908 24.4895 75.5105 3.8092 50 3.8092C24.4895 3.8092 3.8092 24.4895 3.8092 50C3.8092 75.5105 24.4895 96.1908 50 96.1908ZM50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#88C62C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5994 49.9534L60.9368 41.1467H52.5703V35.4342C52.5703 33.0242 53.7369 30.6738 57.4842 30.6738H61.2903V23.1761C61.2903 23.1761 57.8377 22.5811 54.5382 22.5811C47.6447 22.5811 43.1433 26.8 43.1433 34.4345V41.1467H35.4839V49.9534H43.1433V71.2444C44.6811 71.4883 46.2542 71.6133 47.8568 71.6133C49.4594 71.6133 51.0326 71.4883 52.5703 71.2444V49.9534H59.5994Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.72628020c4a37393b4b8c6567a45ac40.svg";
export { ForwardRef as ReactComponent };